// Runtime overrides injected via /config.js (window.PYROSCOUT_CONFIG), loaded in
// index.html before the app bundle. Lets one build serve every environment; the
// values below stay as the baked-in fallback (used when /config.js is absent).
const runtime = (typeof window !== 'undefined' && (window as any).PYROSCOUT_CONFIG) || {}

export const CURRENT_CONFIG = {

  // license
  appId: '154817', // You need to go to the development website to apply.
  appKey: 'cd1dc84a487e4e82b91068db4a7df66', // You need to go to the development website to apply.
  appLicense: 'jgjIYf0hcDHQoUi91ffAQbrDHmoosHqjuKKdBtSBli7Ad4HZWZUilK4p+lYEGuAiqsCFYswLU+hCpiWCQbPApwImpbg8zzI5YL6eWox2f/lRWcvbiwXMlLBfmZSVL+csAiKUI+jyDoj70RNmWISW6wdULHh3BDEAT9W+cb9KHSc=', // You need to go to the development website to apply.

  // http
  // k3s deployment: the backend has its own TLS ingress (backend.pyroscout.com).
  // Must be https/wss because the platform is served over HTTPS (Agora secure context).
  baseURL: runtime.baseURL ?? 'https://backend.pyroscout.com/', // This url must end with "/".
  websocketURL: runtime.websocketURL ?? 'wss://backend.pyroscout.com/api/v1/ws',

  // // livestreaming
  // // RTMP  Note: This IP is the address of the streaming server. If you want to see livestream on web page, you need to convert the RTMP stream to WebRTC stream.
  // rtmpURL: 'Please enter the rtmp access address.', // Example: 'rtmp://192.168.1.1/live/'
  // // GB28181 Note:If you don't know what these parameters mean, you can go to Pilot2 and select the GB28181 page in the cloud platform. Where the parameters same as these parameters.
  // gbServerIp: 'Please enter the server ip.',
  // gbServerPort: 'Please enter the server port.',
  // gbServerId: 'Please enter the server id.',
  // gbAgentId: 'Please enter the agent id',
  // gbPassword: 'Please enter the agent password',
  // gbAgentPort: 'Please enter the local port.',
  // gbAgentChannel: 'Please enter the channel.',
  // // RTSP
  // rtspUserName: 'Please enter the username.',
  // rtspPassword: 'Please enter the password.',
  // rtspPort: '8554',
  // // Agora
  // agoraAPPID: 'Please enter the agora app id.',
  // agoraToken: 'Please enter the agora temporary token.',
  // agoraChannel: 'Please enter the agora channel.',

  // // map
  // // You can apply on the AMap website.
  // amapKey: 'Please enter the amap key.',

}
